import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CaseRequestDto } from '../models/dto/case-overview/case-request-dto.model';
import { ReferenceDataSwitchCaseStatus } from '../constants/reference-data-switch-case-status';

@Injectable()
export class CaseRequestsService {
  public allIustrationsReady: boolean;
  public updateApplicationCase$ = new Subject();

  constructor(private readonly httpClient: HttpClient) {}

  public getCaseRequests(caseId: string): Observable<Array<CaseRequestDto>> {
    const params = new HttpParams().set('caseNumber', caseId);

    return this.httpClient.get<Array<CaseRequestDto>>('/ApplicationCase/GetCaseRequests', { params });
  }

  public getCaseStatuses(caseId: string): Observable<Array<any>> {
    const params = new HttpParams().set('caseNumber', caseId);
    return this.httpClient.get<Array<CaseRequestDto>>('/ApplicationCase/GetCaseRequestsStatuses', { params });
  }

  public areAllIllustrationsReady(cases: CaseRequestDto[]): boolean {
    let res: boolean = true;
    cases.forEach((caseRequest) => {
      if (caseRequest.CurrentStatusCode == ReferenceDataSwitchCaseStatus.IllustrationNotProceeding) return;

      if (caseRequest.CurrentStatusCode !== ReferenceDataSwitchCaseStatus.IllustrationIssued) res = false;
    });

    this.allIustrationsReady = res;
    return res;
  }
}
